import React, {useState, useRef} from 'react';
import Sugar from 'sugar';
import Button from '../modules/Button';
import { useLoseFocus } from '../core/Hooks';

Sugar.extend();

const options = [
  {
    text: "Undergraduate Certificate or Diploma",
    key: 1,
    value: 1
  },

  {
    text: "Associate's Degree",
    key: 2,
    value: 2
  },

  {
    text: "Bachelor's Degree",
    key: 3,
    value: 3
  },

  {
    text: "Post-baccalaureate Certificate",
    key: 4,
    value: 4
  },

  {
    text: "Master's Degree",
    key: 5,
    value: 5
  },

  {
    text: "Doctoral Degree",
    key: 6,
    value: 6
  },

  {
    text: "First Professional Degree",
    key: 7,
    value: 7
  },

  {
    text: "Graduate/Professional Certificate",
    key: 8,
    value: 8
  }

];


function SearchFilter( {selection, onSetSelection} ) {
  const searchRef = useRef();

  const [visible, setVisible] = useState(false);

  const handleChange = () => {
    const checkboxes = Array.from( searchRef.current.querySelectorAll( '.checkbox' ) );
    onSetSelection( checkboxes.filter( x => x.checked ).map( x => parseInt( x.value ) ) );
  }

  const toggleVisible = () => {
    setVisible( !visible );
  }

  useLoseFocus( searchRef, () => visible ? setVisible(false) : null );

  let display = 'All Degrees';

  switch( selection.length )
  {
    case 0:
      display = 'No Degrees';
    break;

    case 8:
      display = 'All Degrees';
    break;

    case 1:
      display = options.find( x => x.value === selection.first() ).text;
    break;

    default:
      display = `${ selection.length } degrees`;
    break;
  }

  return (
    <div className="search-filter">
      <span className="label">FILTER BY:&nbsp;</span>
      <strong className="drop" onClick={ toggleVisible }><span className="ellipsis">{display}</span> &#9662;</strong>
    {
      visible &&
      <div ref={ searchRef } className="search-filter-checkboxes">
        <div className="side-by-side search-filter-buttons">
          <Button className="mini" onClick={ () => onSetSelection([])}><span class="hide-small">Select </span>None</Button>
          <Button className="mini" onClick={ () => onSetSelection([1, 2, 3, 4, 5, 6, 7, 8])}><span class="hide-small">Select </span> All</Button>
        </div>

        {
          options.map( option => <div key={option.key}>
            <label>
            <input className="checkbox" type="checkbox"
              value={option.value}
              name={option.key}
              onChange={ handleChange }
              checked= { selection.indexOf( option.value ) >= 0 }
            />
            { option.text }</label>
        </div>)
        }
      </div>
    }
    </div>
  );
}

SearchFilter.defaultProps = {
  selection: [1, 2, 3, 4, 5, 6, 7, 8],
  onSetSelection: () => null
}


export default SearchFilter;
